/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".file-preview-overlay-container{width:100%;height:100%}file-preview-overlay{display:block;width:100%;height:100%;background-color:rgba(0,0,0,.9);color:#fff;overflow:auto;position:relative}file-preview-overlay preview-container{margin:60px 0;min-height:calc(100% - 120px)}"];
export { styles as styles };
